import Bullet from "./Bullet";
import { ReactComponent as Dropdown } from "../../assets/icons/dropdown.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import Navigation from "./Navigation";
import NavList from "./NavList";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useTranslation } from "react-i18next";

const DropdownContainer: any = styled.div`
  font-weight: bold;
  font-size: 18px;
  padding: 4px 10px;
  cursor: pointer;
  position: relative;
  transition: border ease-in-out 0.3s, height ease-in-out 0.3s;
  height: 30px;
  border: 1px solid transparent;
  border-bottom: none;

  border-radius: 8px 8px 0 0;
  max-width: 260px;
  min-width: 240px;
  ${(p: any) =>
    p.active &&
    css`
      border-color: #ccc;
      background: #fefefe;

      ${DropdownMenu} {
        padding-top: 10px;
        height: 330px;
        width: 100%;
        display: block;
      }
    `}
`;

const DropdownActivator = styled.div`
  display: flex;
  align-items: center;

  :hover {
    ${Bullet} {
      background: red;
    }
  }
`;

const DropdownMenu = styled.div`
  display: none;
  height: 0;
  background: #fefefe;
  z-index: 2;
  left: -1px;
  top: 40px;
  position: absolute;
  overflow: hidden;
  transition: height ease-in-out 0.3s;
  border: 1px solid #ccc;
  border-radius: 0 0 8px 8px;
  border-top: none;
  width: 100%;
  min-width: 240px;

  div {
    padding: 0 20px;
  }
`;

export default ({ current }: any) => {
  const navigation = useSelector((state: RootState) => state.navigation);
  const { t } = useTranslation("navigation");
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(false);
  }, [current.name]);

  return (
    <DropdownContainer active={active}>
      <DropdownActivator onClick={() => setActive(!active)}>
        <Bullet>{!active ? <Dropdown /> : <Close />}</Bullet>
        {t(`games.${current.name}`)}
      </DropdownActivator>
      <DropdownMenu>
        <div>
          <NavList current={current} items={navigation.items} />
        </div>
      </DropdownMenu>
    </DropdownContainer>
  );
};
